const hardwaretimezonedata = [
  {
    id: "auto",
    title: "Auto",
  },
  {
    id: "EST5EDT",
    title: "Eastern Time",
  },
  {
    id: "PST8PDT",
    title: "US Pacific Time",
  },
  {
    id: "AKST9AKDT",
    title: "US Alaska Time",
  },
  {
    id: "TZN+0",
    title: "GMT",
  },
];
export default hardwaretimezonedata;
